import Heading from "components/heading";
import HeroSection from "components/hero-section";

import ExploreMoreIntegrations from "../explore-integrations";
import { integrationDescriptions } from "../integration-descriptions";

const title = "Enerflo Integrates with Software for Sales Qualification, Design, Finance and More";

const CompareIntegrations = () => {
  return (
    <ExploreMoreIntegrations
      title={title}
      items={[integrationDescriptions.sales, integrationDescriptions.design, integrationDescriptions.finance]}
    >
      <HeroSection.Content className="text-center">
        <HeroSection.Header>
          <Heading tag="h2" className="leading-tight max-w-5xl">
            {title}
          </Heading>
        </HeroSection.Header>
        <p className="text-gray-100 text-lg">
          Learn more about how you can speed up your sales process and close deals faster with integrated software.
        </p>
      </HeroSection.Content>
    </ExploreMoreIntegrations>
  );
};

export default CompareIntegrations;
